<script lang="ts">
	import PolicyPage from '$lib/components/PolicyPage.svelte';
	import { m } from '$lib/paraglide/messages';
</script>

<PolicyPage title={m.shipping_title()} description="Shipping and delivery information for Healthy Shoes Cyprus. Free delivery across Cyprus.">
	<p>{m.shipping_intro()}</p>

	<h2>{m.shipping_processing_title()}</h2>
	<p>{m.shipping_processing_body()}</p>

	<h2>{m.shipping_delivery_title()}</h2>
	<p>{m.shipping_delivery_body()}</p>

	<h2>{m.shipping_tracking_title()}</h2>
	<p>{m.shipping_tracking_body()}</p>

	<h2>{m.shipping_cost_title()}</h2>
	<p>{m.shipping_cost_body()}</p>
</PolicyPage>
